<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> O que é o Programa AntecipaGov? </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      O <b>AntecipaGov</b> é uma iniciativa de fomento ao mercado instituída pelo Ministério da Economia, vinculada ao <b>Sistema de Compras do Governo Federal (ComprasNet 4.0)</b>. Permite que fornecedores utilizem os créditos a receber de seus contratos administrativos, ou empenhos com força de contrato, como garantia para solicitar empréstimos e financiamentos em instituições financeiras credenciadas pelo Ministério da Economia (ME).
    </p>
    <p>
      As operações são realizadas por meio do Portal de Crédito AntecipaGov de maneira ágil, padronizada, transparente e segura. O portal de Crédito é a plataforma que realizará as operações de crédito de antecipação de recebíveis. O portal traz informações sobre os contratos e empenhos, faz conexão entre o mercado fornecedor, a Administração Pública e as instituições financeiras. <b class="text-primary-dark-blue">A Broadfactor foi a primeira plataforma gestora a se credenciar e hoje somos referência quando o assunto é AntecipaGov</b>.
    </p>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Quem pode participar do Programa AntecipaGov?</mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      <b>Fornecedores da Administração Pública Federal</b> participam solicitando cotações de operações de crédito. A oferta do crédito está disponível a todos os fornecedores que possuem contrato administrativo ativo com o Governo Federal (órgãos pertencentes ao SISG ou que utilizem o sistema Comprasnet Contratos), de modo a estimular a oferta de crédito, com menor risco, reduzindo custos da operação.
    </p>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Quais contratos e empenhos podem ser utilizados?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Os fornecedores poderão apresentar às instituições <b>um ou mais contratos, e empenhos com força de contrato,
      vigentes com a Administração Pública Federal de órgãos pertencentes ao SISG ou que operem no sistema Comprasnet Contratos</b>,
      solicitando uma antecipação do crédito. Para isto ocorrer, os respectivos contratos administrativos celebrados devem prever a
      possibilidade de cessão dos créditos decorrentes da contratação. Para aqueles contratos celebrados antes da publicação da <b>IN nº 53/2020, da SEGES/ME,</b>
      será necessário aditivo contratual prevendo tal possibilidade.
      Não há necessidade de adequação no caso de empenhos com força de contrato.
      <b>Você pode solicitar sua cotação acessando o portal do antecipagov </b> <a href="https://antecipagov.comprasnet.gov.br/" target="_blank">https://antecipagov.comprasnet.gov.br/</a> .
    </p>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Fiz uma solicitação de antecipação de recebíveis, qual o próximo passo?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      <b>Em até 15 (quinze) dias úteis a contar do envio da cotação pelo fornecedor</b>, os órgãos e as entidades do Governo gestoras dos contratos e/ou empenhos indicados pelo fornecedor deverão analisar os contratos e/ou empenhos relacionados ao pedido de operação de crédito.
      <b>Caso a análise não seja realizada no prazo de 15 (quinze) dias úteis, a cotação será liberada para o envio de propostas pelas instituições</b>. Após essa análise feita pelo órgão, sua cotação estará disponível na plataforma da Broadfactor, nesta fase os Financiadores podem identificar sua intenção de antecipação, por isso realize seu cadastro em nossa plataforma e anexe o máximo de documentos, isso ajudará na análise de crédito e nas condições de taxa e prazo. <b>O cadastro é gratuito e o ambiente é seguro</b>. <a href="https://plataforma.antecipagov.com.br/cadastro" target="_blank">https://plataforma.antecipagov.com.br/cadastro</a>
    </p>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Após minha solicitação é garantido que consigo antecipar meus contratos? </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      <b>Não, como toda operação de crédito comercial, existe uma análise a ser feita</b>. No caso do programa AntecipaGov, os Financiadores avaliam os documentos da empresa e dos sócios, a saúde financeira, capacidade de pagamento em caso de uma ruptura contratual, é realizado uma análise do contrato e sua execução baseando-se nas respostas informadas pelos órgão.
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Como é realizado o pagamento do Financiamento?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      As instituições credoras receberão <b>o pagamento mediante conta vinculada do fornecedor, aberta e gerida pela Broadfactor</b>.
      O governo deposita nessa conta, a <b>Broadfactor amortiza o saldo devedor e transfere os recursos livres para a conta indicada pelo fornecedor</b>.
      Para ter acesso à antecipação de créditos, <b>o fornecedor deverá assinar um termo de vinculação de domicílio bancário (anexo II da IN nº 53/2020 da SEGES/ME).
      Esta conta será bloqueada para movimentação, visando o pagamento dos créditos cedidos fiduciariamente em garantia.</b>
      Após a liquidação total do contrato, o fornecedor volta a receber em uma conta de sua preferência.
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Quais são os benefícios para os fornecedores?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Recebimento antecipado de valores devidos, melhoria do fluxo de caixa, recursos para investir em novas licitações,
      investimento em máquinas e equipamentos, sem necessidade de garantias extras, apenas seu contrato fica em garantia e condições mais vantajosas
      em relação a empréstimos tradicionais.
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Existe custo para se cadastrar na Broadfactor?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Não, <b>o fornecedor não paga nada para se cadastrar em nossa plataforma</b>. Nela você pode anexar todos seus documentos que serão usados na análise de crédito. <a href="https://plataforma.antecipagov.com.br/cadastro" target="_blank">https://plataforma.antecipagov.com.br/cadastro</a>
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        O Governo Federal será solidário (ou garantidor) da operação de crédito/empréstimo celebrada entre os fornecedores e as instituições credoras?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Não. A operação de crédito garantida por cessão fiduciária dos direitos de créditos decorrentes de contratos administrativos, de que trata a
      <b>
        Instrução Normativa nº 53, de 8 de julho de 2020, não representa garantia da União aos financiamentos concedidos pelas instituições credoras aos fornecedores
      </b>. Esta informação é parte integrante do Termo de adesão ao Portal de Crédito Digital (item ii) da alínea 'f' do item 5),
      que serão subscritos pelos agentes de crédito (Portaria nº 21.332, de 25 de setembro de 2020).
    </p>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Onde obter mais informações?
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li>Instrução Normativa nº 53, de 8 de julho de 2020; </li>
      <li>Instrução Normativa nº 42, de 19 de abril de 2021;</li>
      <li>Instrução Normativa nº 62, de 28 de junho de 2021; </li>
      <li>Portaria nº 21.332, de 25 de setembro de 2020; </li>
      <li>Manual de Integração com o Portal AntecipaGov; </li>
      <li>Tutorial do Fornecedor;</li>
      <li>Loja Serpro.</li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
